<app-model-selection-bar/>



<div class="main-content-wrapper">
    <!-- <div class="tabs-bar"> -->
        <mat-tab-group
            class="tabs-bar"
            (selectedIndexChange)="onTabChange($event)"
            [selectedIndex]="activeTabIndex">
                <mat-tab label="Model Predictions" [disabled]="isTabDisabled(1)"></mat-tab>
                <mat-tab label="Model Accuracy" [disabled]="isTabDisabled(2)"></mat-tab>
                <mat-tab label="Trading Strategy" [disabled]="isTabDisabled(3)"></mat-tab>
                <mat-tab label="Model Definitions" [disabled]="isTabDisabled(4)"></mat-tab>
                <mat-tab label="Feedback" [disabled]="isTabDisabled(5)"></mat-tab>

                  <!-- <mat-tab label="Model Predictions" [disabled]="project.length===0 || !canViewModelPredictions()"></mat-tab>
                    <mat-tab label="Model Accuracy" [disabled]="project.length===0 || !canViewModelAccuracy()"></mat-tab>
                    <mat-tab label="Trading Strategy" [disabled]="project.length===0 || !canViewTrading()"></mat-tab>
                    <mat-tab label="Model Definitions" [disabled]="project.length===0 || !canViewModelDefinitions()"></mat-tab> -->
                    <!-- <mat-tab label="Feedback" [disabled]="project.length===0"></mat-tab> -->
        </mat-tab-group>
    <!-- </div> -->
    <div class="content-container">
    <router-outlet />
    </div>
</div>

<app-cvx-footer [pLastSync]="lastSync()" />
